import React from "react";
import "../assets/styles/Gallery.scss";
import photo1 from "../assets/images/gallery/1.jpeg";
import photo2 from "../assets/images/gallery/2.jpeg";
import photo3 from "../assets/images/gallery/3.jpeg";
import photo4 from "../assets/images/gallery/4.jpeg";
import photo5 from "../assets/images/gallery/5.jpeg";
import photo6 from "../assets/images/gallery/6.jpeg";
import photo7 from "../assets/images/gallery/7.jpeg";

const images = [
  { src: photo1, alt: "" },
  { src: photo2, alt: "" },
  { src: photo3, alt: "" },
  { src: photo4, alt: "" },
  { src: photo5, alt: "" },
  { src: photo6, alt: "" },
  { src: photo7, alt: "" },
];

function Gallery() {
  return (
    <div id="gallery" className="gallery-container">
      <h1>Gallery</h1>
      <div className="gallery-grid">
        {images.map((image) => (
          <div className="gallery-item" key={image.src}>
            <img
              className="zoom"
              src={image.src}
              alt={image.alt}
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Gallery;
